<div class="clips-form-container" [id]="'tag-dropzone-form'" cdkDropList (cdkDropListDropped)="tagsDropAssign.drop($event)">
	<span #clipsFormComponent></span>
	<form [formGroup]="clipFormGroup" #formClipsDirective="ngForm" (submit)="submitClipsForm(formClipsDirective, $event)">
		<div class="row mx-1">
			<mat-form-field class="field-with-insert-button col-12 col-lg-3 mt-2">
				<mat-label for="clip-medium">{{ 'CLIPS.MEDIUM' | translate }}</mat-label>
				<input tabindex="1" type="text" matInput formControlName="medium" [matAutocomplete]="mediumAutocomplete" cdkFocusInitial />
				<mat-autocomplete #mediumAutocomplete="matAutocomplete" [displayWith]="displayFn.bind(this)" (optionSelected)="onMediumAutocompleteSelected($event)">
					@for (filteredItem of filteredMediums; track $index) {
					<mat-option [value]="filteredItem" (onSelectionChange)="checkFormValidity()">{{ utils.getParameterByLanguageScript(filteredItem, 'name') }}</mat-option>
					}
				</mat-autocomplete>
				<button
					matSuffix
					mat-button
					type="button"
					color="primary"
					aria-label="Add business entity"
					matTooltip="{{ 'BUTTON.CREATE' | translate }} {{ 'MEDIUM.TITLE' | translate }}"
					matTooltipPosition="below"
					(click)="itemAction('CREATE', 'MEDIUM', clipFormGroup.controls['medium'].value)">
					<mat-icon class="m-0">add</mat-icon>
				</button>
			</mat-form-field>

			<mat-form-field class="ms-1 col-12 col-lg-3 mt-2">
				<mat-label for="clip-date">{{ 'CLIPS.DATE' | translate }}</mat-label>
				<input tabindex="-1" matInput id="clip-date" (blur)="dateInput($event)" [matDatepicker]="picker" formControlName="publicationDate" />
				<mat-datepicker-toggle tabindex="-1" matIconSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>

			<div class="col d-flex flex-wrap align-items-center">
				<button mat-icon-button type="button" aria-label="Related clips button" (click)="getDataFromClipBoard()" [disabled]="!plugins.webClipPopulateFromClipboard">
					<mat-icon>assignment_add</mat-icon>
				</button>
				<button mat-icon-button type="button" class="ms-1" aria-label="Upload progress" (click)="showUploadStatus()">
					<mat-icon [color]="uploadInProgressCheck() ? 'warn' : 'primary'">outbox</mat-icon>
				</button>

				<button
					type="button"
					mat-raised-button
					color="primary"
					class="ms-auto mt-2"
					aria-label="Screenshot queue button"
					matTooltip="{{ 'CLIPS.SCREENSHOT_QUEUE' | translate }}"
					matTooltipPosition="below"
					(click)="openScreenshotQueue()">
					<mat-icon class="m-0" fontSet="material-icons-outlined">web_stories</mat-icon>
				</button>

				<button
					type="button"
					mat-raised-button
					color="primary"
					class="ms-1 mt-2"
					aria-label="Import clips from csv button"
					matTooltip="{{ 'CLIPS.IMPORT' | translate }}"
					matTooltipPosition="below"
					[disabled]="apiLoading.importClips"
					(click)="importClips()">
					@if(apiLoading.importClips) {
					<mat-spinner diameter="20"></mat-spinner>
					} @else {
					<mat-icon class="m-0">upload_file</mat-icon>
					}
				</button>

				<button
					type="button"
					mat-raised-button
					color="primary"
					class="ms-1 mt-2"
					aria-label="Translate clips by tags"
					matTooltip="{{ 'CLIPS.TRANSLATE_BY_TAG' | translate }}"
					matTooltipPosition="below"
					[disabled]="apiLoading.translateClipsByTag"
					(click)="showTranslateClipsByTagsConfirmation()">
					@if(apiLoading.translateClipsByTag) {
					<mat-spinner diameter="20"></mat-spinner>
					} @else {
					<mat-icon class="m-0">translate</mat-icon>
					}
				</button>

				<button
					type="button"
					mat-raised-button
					color="primary"
					class="ms-1 mt-2"
					aria-label="Open tools button"
					matTooltip="{{ 'CLIPS.TOOLS' | translate }}"
					matTooltipPosition="below"
					[disabled]="apiLoading.reportByTag || apiLoading.mergeBySimilarity"
					(click)="openTools()">
					@if(apiLoading.reportByTag || apiLoading.mergeBySimilarity) {
					<mat-spinner diameter="20"></mat-spinner>
					} @else {
					<mat-icon class="m-0">construction</mat-icon>
					}
				</button>

				<app-split-button
					class="ms-1 mt-2"
					[buttonsData]="{ buttonLabel: 'CLIPS.SEARCH_FOR_KEYWORDS', buttonIcon: 'calendar_month', buttonLoading: apiLoading.searchKeywords }"
					(clickedButton)="searchForKeywordsButton($event)">
				</app-split-button>
			</div>
		</div>

		<!-- Multi language tabs -->
		<div class="px-3">
			<mat-tab-group [(selectedIndex)]="selectedTabIndex" mat-stretch-tabs="false" mat-align-tabs="start">
				@for (langCode of avaliableLanguagesCodes; track $index) {
				<mat-tab label="" class="p-0">
					<!-- Tab names -->
					<ng-template mat-tab-label>
						<span>{{ 'NAVBAR.LANGUAGES.' + langCode | uppercase | translate }}</span>
						<button
							mat-icon-button
							type="button"
							color="primary"
							aria-label="Translate"
							matTooltip="{{ (getTranslatedStatus(langCode) ? 'CLIPS.TRANSLATED' : 'CLIPS.NOT_TRANSLATED') | translate }}"
							(click)="translateClipText(langCode)">
							<div class="d-flex">
								@if(apiLoading.translate) {
								<mat-spinner diameter="23" class="me-1"></mat-spinner>
								} @else {
								<mat-icon [ngClass]="getTranslatedStatus(langCode) ? 'active' : 'disabled'" [color]="getTranslatedStatus(langCode) ? 'primary' : 'accent'">title</mat-icon>
								}
							</div>
						</button>
					</ng-template>
					<!-- (END)Tab names -->

					<mat-form-field class="w-100 mt-2 pb-2">
						<mat-label>{{ 'CLIPS.TITLE' | translate }}</mat-label>
						<input tabindex="2" type="text" matInput [formControlName]="'title' + (langCode | titlecase)" />
					</mat-form-field>

					<div class="row">
						<!-- Left side fileds -->
						<div class="col-7 pe-0">
							<mat-form-field class="w-100 pb-2">
								<mat-label>{{ 'CLIPS.TEXT' | translate }}</mat-label>
								<textarea
									#clipTextArea
									tabindex="3"
									matInput
									[formControlName]="'text' + (langCode | titlecase)"
									class="pt-2"
									cdkTextareaAutosize
									[cdkAutosizeMinRows]="clipFormGroup.controls['medium'].value?.type === 'PRINTED' ? 18 : 9"
									[cdkAutosizeMaxRows]="clipFormGroup.controls['medium'].value?.type === 'PRINTED' ? 18 : 9"></textarea>
							</mat-form-field>

							<mat-form-field floatLabel="always" class="w-100 pb-2">
								<mat-label>{{ 'CLIPS.SCREENSHOT' | translate }}</mat-label>
								<input type="text" matInput formControlName="screenshotUrl" readonly />
								<button class="me-1" mat-icon-button matSuffix type="button" (click)="fileInput.click()" aria-label="Choose file">
									<mat-icon color="primary">upload</mat-icon>
								</button>
								<input hidden (change)="selectScreenshotForUpload($event)" [accept]="getAcceptedFileFormats()" #fileInput type="file" id="file" />
							</mat-form-field>

							<div class="tags-placeholder d-flex gap-2 flex-row flex-wrap flex-fill ps-1 pt-1">
								@for (tag of assignedTags; track $index) {
								<div [style.background-color]="utils.getParameterByName(tag, 'colorCode')" class="tag-item d-flex align-items-center list-item">
									<span (click)="removeTag(tag)">
										{{ utils.getParameterByName(tag, 'value') }}
									</span>
								</div>
								}
							</div>
						</div>
						<!-- (END)Left side fileds -->

						<!-- Right side fields -->
						<div class="col-5 ps-0">
							<mat-form-field class="w-100 ps-1 pb-2">
								<mat-label>{{ 'CLIPS.BRIEF' | translate }}</mat-label>
								<textarea matInput [formControlName]="'brief' + (langCode | titlecase)" class="pt-2" cdkTextareaAutosize cdkAutosizeMinRows="5"></textarea>
							</mat-form-field>
							<br />
							<mat-form-field class="field-with-insert-button w-100 ps-1 pb-2">
								<mat-label>{{ 'CLIPS.AUTHOR' | translate }}</mat-label>
								<mat-chip-grid #autorGrid aria-label="Authors selection">
									@for (author of selectedAuthors; track $index) {
									<mat-chip-row (removed)="itemAction('REMOVE', 'AUTHOR', author)">
										{{ utils.getParameterByLanguageScript(author, 'name') }}
										<button matChipRemove [attr.aria-label]="'remove ' + author.id">
											<mat-icon>cancel</mat-icon>
										</button>
									</mat-chip-row>
									}
								</mat-chip-grid>
								<input
									[placeholder]="'BUTTON.SEARCH' | translate"
									#authorInput
									formControlName="author"
									[matChipInputFor]="autorGrid"
									[matAutocomplete]="autoAuthors"
									[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
									(matChipInputTokenEnd)="itemAction('ADD', 'AUTHOR', $event)" />
								<mat-autocomplete #autoAuthors="matAutocomplete" (optionSelected)="itemAction('SELECT', 'AUTHOR', $event)">
									@for (author of filteredAuthors; track $index) {
									<mat-option [value]="author">{{ utils.getParameterByLanguageScript(author, 'name') }}</mat-option>
									}
								</mat-autocomplete>
								<button
									matSuffix
									mat-button
									type="button"
									color="primary"
									aria-label="Add author"
									matTooltip="{{ 'BUTTON.CREATE' | translate }} {{ 'AUTHOR.TITLE' | translate }}"
									matTooltipPosition="below"
									(click)="itemAction('CREATE', 'AUTHOR', clipFormGroup.controls['author'].value)">
									<mat-icon class="m-0">add</mat-icon>
								</button>
							</mat-form-field>

							<!-- Printed clips fields -->
							@if (clipFormGroup.controls['medium'].value?.type === 'PRINTED') {
							<mat-card class="mb-2">
								<mat-card-content>
									<div class="row">
										<mat-form-field class="col ms-1 w-100">
											<mat-label>{{ 'CLIPS.SIF' | translate }}</mat-label>
											<input type="text" matInput formControlName="sif" />
										</mat-form-field>
									</div>

									<div class="row">
										<mat-form-field class="col ms-1 w-100 my-1">
											<mat-label>{{ 'CLIPS.PAGE' | translate }}</mat-label>
											<input type="text" matInput formControlName="pageNumber" />
										</mat-form-field>

										<div class="d-flex col align-items-start">
											<span class="form-span pt-3 me-2">{{ 'CLIPS.AREA' | translate }}</span>
											<mat-slider class="w-100" min="0" max="12" step="1" showTickMarks discrete [displayWith]="pageAreaLabel">
												<input matSliderThumb formControlName="area" />
											</mat-slider>
										</div>
									</div>

									<div class="row mb-1">
										<div class="col-lg-2 col-md-3 align-self-center">
											<span class="form-span pt-2 me-2">{{ 'CLIPS.COVER' | translate }}:</span>
										</div>
										<div class="col-lg-10 col-md-9">
											<mat-button-toggle-group formControlName="printedOptionsCover" appearance="legacy" name="cover-toggle" aria-label="Cover toggle">
												<mat-button-toggle value="isCover">
													<span>{{ 'ASSORTED.YES' | translate }}</span>
												</mat-button-toggle>
												<mat-button-toggle value="notCover">
													<span>{{ 'ASSORTED.NO' | translate }}</span>
												</mat-button-toggle>
											</mat-button-toggle-group>
										</div>
									</div>

									<div class="row mb-1">
										<div class="col-lg-2 col-md-3 align-self-center">
											<span class="form-span pt-2 me-2">{{ 'CLIPS.IMAGE' | translate }}:</span>
										</div>
										<div class="col-lg-10 col-md-9">
											<mat-button-toggle-group formControlName="printedOptionsImage" color="primary" appearance="legacy" name="image-toggle" aria-label="Image toggle">
												<mat-button-toggle value="withImage">
													<span>{{ 'CLIPS.WITH_IMAGE' | translate }}</span>
												</mat-button-toggle>
												<mat-button-toggle value="withoutImage">
													<span>{{ 'CLIPS.WITHOUT_IMAGE' | translate }}</span>
												</mat-button-toggle>
											</mat-button-toggle-group>
										</div>
									</div>

									<div class="row mb-1">
										<div class="col-lg-2 col-md-3 align-self-center">
											<span class="form-span pt-2 me-2">{{ 'CLIPS.RESEARCH' | translate }}:</span>
										</div>
										<div class="col-lg-10 col-md-9">
											<mat-button-toggle-group formControlName="printedOptionsResearch" appearance="legacy" name="research-toggle" aria-label="Research toggle">
												<mat-button-toggle value="own">
													<span>{{ 'CLIPS.OWN' | translate }}</span>
												</mat-button-toggle>
												<mat-button-toggle value="taken">
													<span>{{ 'CLIPS.TAKEN' | translate }}</span>
												</mat-button-toggle>
												<mat-button-toggle value="transferred">
													<span>{{ 'CLIPS.TRANSFERRED' | translate }}</span>
												</mat-button-toggle>
											</mat-button-toggle-group>
										</div>
									</div>

									<div class="row mb-1">
										<div class="col-lg-2 col-md-3 align-self-center">
											<span class="form-span pt-2 me-2">{{ 'CLIPS.RELEVANCY' | translate }}:</span>
										</div>
										<div class="col-lg-10 col-md-9">
											<mat-button-toggle-group formControlName="printedOptionsRelevancy" appearance="legacy" name="relevancy-toggle" aria-label="Relevancy toggle">
												<mat-button-toggle value="mentioned_client">
													<span>{{ 'CLIPS.MENTIONED_CLIENT' | translate }}</span>
												</mat-button-toggle>
												<mat-button-toggle value="narower_area">
													<span>{{ 'CLIPS.NARROWER_AREA' | translate }}</span>
												</mat-button-toggle>
												<mat-button-toggle value="wider_area">
													<span>{{ 'CLIPS.WIDER_AREA' | translate }}</span>
												</mat-button-toggle>
											</mat-button-toggle-group>
										</div>
									</div>
								</mat-card-content>
							</mat-card>
							}
							<!-- (END)Printed clips fields -->

							@if (clipFormGroup.controls['medium'].value?.type === 'TV' || clipFormGroup.controls['medium'].value?.type === 'RADIO' || clipFormGroup.controls['medium'].value?.type
							=== 'PRINTED') {
							<mat-form-field floatLabel="always" class="w-100 ps-1 pb-2">
								<mat-label>{{ 'CLIPS.PATH' | translate }}</mat-label>
								<input type="text" matInput formControlName="mediaUrl" readonly />
								<button class="me-1" mat-icon-button matSuffix type="button" (click)="fileInput.click()" aria-label="Choose file">
									<mat-icon color="primary">upload</mat-icon>
								</button>
								<input hidden (change)="selectFilesForUpload($event)" [accept]="getAcceptedFileFormats()" #fileInput type="file" id="file" />
							</mat-form-field>
							} @else {
							<mat-form-field class="w-100 ps-1 pb-2">
								<mat-label>{{ 'CLIPS.LINK' | translate }}</mat-label>
								<input type="text" matInput formControlName="url" />
							</mat-form-field>
							}

							<div class="d-flex justify-content-between">
								<mat-checkbox class="w-15" color="primary" formControlName="important">{{ 'CLIPS.IMPORTANT_INFO' | translate }}</mat-checkbox>

								<mat-checkbox class="w-15" color="primary" formControlName="hasVideo">{{ 'CLIPS.HAS_VIDEO' | translate }}</mat-checkbox>

								<mat-form-field class="w-15 ps-1 pb-2">
									<mat-label>{{ 'CLIPS.VIDEO_START' | translate }}</mat-label>
									<input type="text" matInput placeholder="mm:ss" formControlName="videoStartSeconds" />
									<mat-error *ngIf="clipFormGroup.controls['videoStartSeconds'].hasError('pattern')">
										{{ 'CLIPS.INVALID_TIME_FORMAT' | translate }}
									</mat-error>
								</mat-form-field>
								@if (showBoundaryPlayer) {
								<button mat-stroked-button type="button" class="from-player-btn" (click)="setVideoStartFromPlayer()">{{ 'CLIPS.SET_FROM_PLAYER' | translate }}</button>
								}

								<mat-form-field class="w-15 ps-1 pb-2">
									<mat-label>{{ 'CLIPS.VIDEO_END' | translate }}</mat-label>
									<input type="text" matInput placeholder="mm:ss" formControlName="videoEndSeconds" />
									<mat-error *ngIf="clipFormGroup.controls['videoEndSeconds'].hasError('pattern')">
										{{ 'CLIPS.INVALID_TIME_FORMAT' | translate }}
									</mat-error>
								</mat-form-field>
								@if (showBoundaryPlayer) {
								<button mat-stroked-button type="button" class="from-player-btn" (click)="setVideoEndFromPlayer()">{{ 'CLIPS.SET_FROM_PLAYER' | translate }}</button>
								}

								@if (clipFormGroup.controls['medium'].value?.type === 'TV' || clipFormGroup.controls['medium'].value?.type === 'RADIO') {
								<mat-checkbox class="w-15" color="primary" formControlName="transcription">{{ 'CLIPS.AUTO_TRANSCRIPTION' | translate }}</mat-checkbox>
								}

								@if (showBoundaryPlayer) {
								<div class="boundary-player-wrap w-100">
									<video
										#boundaryPlayer
										[src]="clipFormGroup.controls['mediaUrl'].value"
										controls
										preload="metadata"
										class="boundary-player"
										(loadedmetadata)="onBoundaryPlayerLoadedMetadata()"
										(timeupdate)="onBoundaryPlayerTimeUpdate()"
										(seeked)="onBoundaryPlayerSeeked()"></video>
								</div>
								}

								<mat-form-field [class]="(clipFormGroup.controls['medium'].value?.type === 'TV' || clipFormGroup.controls['medium'].value?.type === 'RADIO') ? 'w-25 ps-1 pb-2' : 'w-30 ps-1 pb-2'">
									<mat-label>{{ 'CLIPS.TYPE' | translate }}</mat-label>
									<select id="type" style="display: none"></select>
									<!-- workaround for material-chrome bug -->
									<mat-select id="type" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="type">
										<mat-option value="NEUTRAL">{{ 'CLIPS.CLIP_TYPE.NEUTRAL' | translate }}</mat-option>
										<mat-option value="PROMOTIONAL">{{ 'CLIPS.CLIP_TYPE.PROMOTIONAL' | translate }}</mat-option>
										<mat-option value="ABUSIVE">{{ 'CLIPS.CLIP_TYPE.ABUSIVE' | translate }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>

						<!-- (END)Right side fields -->
					</div>
				</mat-tab>
				}
			</mat-tab-group>
		</div>
		<!-- (END)Multi language tabs -->

		<div class="d-flex mt-3 mx-3">
			<button
				type="button"
				mat-raised-button
				color="primary"
				class="me-1"
				aria-label="Reset form button"
				matTooltip="{{ 'CLIPS.RESET_FORM' | translate }}"
				matTooltipPosition="below"
				[disabled]="apiLoading.clip"
				(click)="resetForm(formClipsDirective, true)">
				<mat-icon class="m-0">restart_alt</mat-icon>
			</button>

			<button type="submit" mat-raised-button color="primary" class="w-100" aria-label="Create clip button" [disabled]="!checkFormValidity() || apiLoading.clip">
				@if(apiLoading.clip) {
				<mat-spinner diameter="20"></mat-spinner>
				} @else {
				<span>{{ 'BUTTON.' + mode | translate }} {{ 'CLIPS.CLIP' | translate }}</span>
				}
			</button>
		</div>
	</form>

	<!-- Cluster form -->
	<div class="divider-text my-2">
		<div class="start-line"><mat-divider></mat-divider></div>
		<div class="text">{{ 'CLIPS.CLUSTER' | translate }}</div>
		<div class="end-line"><mat-divider></mat-divider></div>
	</div>

	<form [formGroup]="clusterFormGroup" #formClusterDirective="ngForm" (submit)="createCluster(formClusterDirective, $event)" class="mx-3">
		<div class="d-flex">
			<mat-form-field class="me-1 flex-fill" appearance="outline">
				<mat-label>{{ 'CLIPS.LINK' | translate }}</mat-label>
				<input type="text" matInput formControlName="clusterId" />
			</mat-form-field>

			<button mat-raised-button color="primary" class="w-25" type="submit" aria-label="Create clip button" [disabled]="!clusterFormGroup.valid || apiLoading.cluster">
				@if(apiLoading.cluster) {
				<mat-spinner diameter="20"></mat-spinner>
				} @else {
				<span>{{ 'BUTTON.NEW' | translate }} {{ 'CLIPS.CLUSTER' | translate }}</span>
				}
			</button>
		</div>
	</form>
	<!-- (END)Cluster form -->
</div>
